import * as types from './ActionTypes';
import axios from 'utils/axios';
import { API_URL } from 'configs';
import { showSuccessModal } from 'actions';

const loader = label => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = 'general_error') => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType = '') => {
  const res = error?.response; 
  if (res?.status === 422){ 
    dispatch({ type: validationType, validation_error: res.data.errors });
  } 
  else dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
};

export const getACDDailyTotalReport = (data = {}) => dispatch => {
  dispatch({ type: types.FETCH_ACD_DAILY_TOTAL_REPORT });
  dispatch(loader());

  axios.get(`${API_URL}acd-reports/daily`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    params: data
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch({
        type: types.FETCH_ACD_DAILY_TOTAL_REPORT_SUCCESS,
        payload: res.data,
    });
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.FETCH_ACD_DAILY_TOTAL_REPORT_FAILURE);
    });
};

export const getACDQueueReport = (data = {}) => dispatch => {
  dispatch({ type: types.FETCH_ACD_DAILY_QUEUE_REPORT });
  dispatch(loader());

  axios.get(`${API_URL}acd-reports/queue-wise`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    params: data
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch({
        type: types.FETCH_ACD_DAILY_QUEUE_REPORT_SUCCESS,
        payload: res.data,
    });
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.FETCH_ACD_DAILY_QUEUE_REPORT_FAILURE);
    });
};

export const getACDMonthlyTotalReport = (data = {}) => dispatch => {
  dispatch({ type: types.FETCH_ACD_MONTHLY_TOTAL_REPORT });
  dispatch(loader());

  axios.get(`${API_URL}acd-reports/monthly`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    params: data
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch({
        type: types.FETCH_ACD_MONTHLY_TOTAL_REPORT_SUCCESS,
        payload: res.data,
    });
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.FETCH_ACD_MONTHLY_TOTAL_REPORT_FAILURE);
    });
};

export const getACDTotalDashboardReport = (data = {}) => dispatch => {
  dispatch({ type: types.FETCH_ACD_TOTAL_DASHBOARD_REPORT });
  dispatch(loader());

  axios.get(`${API_URL}acd-reports/program-wise`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    params: data
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch({
        type: types.FETCH_ACD_TOTAL_DASHBOARD_REPORT_SUCCESS,
        payload: res.data,
    });
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.FETCH_ACD_TOTAL_DASHBOARD_REPORT_FAILURE);
    });
};


export const exportProgramWiseACDReport = (data = {}) => dispatch => {
  dispatch(loader('Exporting...'));
  const token = localStorage.getItem("token");
  const url = `${API_URL}acd-reports/export/program-wise`;

  axios.post(url, {...data}, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  .then(response => {
    const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = urlBlob;
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'SummaryACD.xlsx';
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch.length > 1)
            filename = filenameMatch[1];
    }
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(urlBlob);
    dispatch(hideLoader());
  }).catch(error => {
    dispatch(hideLoader());
    handleError(error, dispatch);
  });
};

export const exportMonthlyACDReport = (data = {}) => dispatch => {
  dispatch(loader('Exporting...'));
  const token = localStorage.getItem("token");
  const url = `${API_URL}acd-reports/export/monthly`;

  axios.post(url, {...data}, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  .then(response => {
    const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = urlBlob;
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'MonthlyACD.xlsx';
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch.length > 1)
            filename = filenameMatch[1];
    }
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(urlBlob);
    dispatch(hideLoader());
  }).catch(error => {
    dispatch(hideLoader());
    handleError(error, dispatch);
  });
};

export const exportDailyACDReport = (data = {}) => dispatch => {
  dispatch(loader('Exporting...'));
  const token = localStorage.getItem("token");
  const url = `${API_URL}acd-reports/export/daily`;

  axios.post(url, {...data}, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  .then(response => {
    const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = urlBlob;
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'DailyACD.xlsx';
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch.length > 1)
            filename = filenameMatch[1];
    }
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(urlBlob);
    dispatch(hideLoader());
  }).catch(error => {
    dispatch(hideLoader());
    handleError(error, dispatch);
  });
};

export const exportProgramWiseACDPDFReport = (data = {}) => dispatch => {
  dispatch(loader('Exporting...'));
  const token = localStorage.getItem("token");
  const url = `${API_URL}acd-reports/export/programs/zip`;

  axios.post(url, {...data}, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  .then(response => {
    const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = urlBlob;
    const contentDisposition = response.headers['content-disposition'];
    const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const monthAbbreviation = monthNames[data.month - 1];
    const yearAbbreviation = String(data.year).slice(-2);
    let filename = `${monthAbbreviation}${yearAbbreviation}_Billing.zip`;
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch.length > 1)
          filename = filenameMatch[1];
    }
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(urlBlob);
    dispatch(hideLoader());
  }).catch(error => {
    dispatch(hideLoader());
    handleError(error, dispatch);
  });
};
